import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { catchError, map, of } from 'rxjs';
import { GetCodiceOperatoreGQL } from '../../_graphql/generated';

export function codiceOperatoreValidator(
  control: AbstractControl,
  field: FormlyFieldConfig,
  options: any,
): ValidationErrors | null {
  const value = (control.value || '').trim();
  if (!value) return of(null);
  if (
    options.currentCode &&
    value.toUpperCase() === `${options.currentCode}`.trim().toUpperCase()
  ) {
    return of(null);
  }

  // (options.loading as LoadingService).start();

  return (options.getter as GetCodiceOperatoreGQL)
    .fetch(
      {
        where: {
          codice: {
            _eq: value.toUpperCase(),
          },
        },
      },
      {
        context: {
          headers: { 'x-hasura-role': options.role ?? 'anonymous' },
        },
      },
    )
    .pipe(
      map((res) => {
        // (options.loading as LoadingService).stop();
        return ((res?.data?.codice_operatore ?? []) as any).length > 0
          ? null
          : { codiceOperatore: true }; // null = valido
      }),
      catchError(() => {
        // (options.loading as LoadingService).stop();
        return of({ codiceOperatore: true });
      }),
    );
}
